import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const iconDemo = {
    code:
`<GridRow style={{ wordBreak: "break-word", textAlign: "center" }}>
    {Object.keys(iconTable).map(iconName =>
        <GridCell span={3} key={iconName}>
            <Icon name={iconName} />
            <p>{iconName}</p>
        </GridCell>
    )}
</GridRow>`
};

export const IconDemo: FunctionComponent = () => {
    return (
        <Demo demo={iconDemo}>
            <ComponentProps componentName="Icon" />
        </Demo>
    );
};

const typedIconDemo = {
    code: "<AccountIcon />"
};

export const TypedIconDemo: FunctionComponent = () => {
    return (
        <Demo demo={typedIconDemo}>
            <ComponentProps componentName="AccountIcon" />
        </Demo>
    );
};
